export enum EmployeeReviewSummaryStatus {
    notStarted = 1,
    inProgress = 2,
    waitingOnEmployee = 3,
    readyForReview = 4,
    complete = 6,
    deleted = 7,
}
